<template>
    <div v-if="!loading">
        <!-- header section 1 -->
        <div style="display: grid; grid-template-columns: repeat(4, 1fr);" class="px-8 pt-8 pb-2">
            <div>
                <v-img :src="getImgSrc(getReviewSource(review.source))" alt="" :aspect-ratio="getImgAspectRatio(getReviewSource(review.source))" :width="getImgWidth(getReviewSource(review.source))"/>
            </div>
            <div>
                <div style="display: grid; grid-template-columns: 2fr 3fr;">
                    <div style="font-weight: 700;">Accommodation</div>
                    <div>{{ review.huis_code }}</div>
                    <div>Contracttype</div>
                    <div :class="{'exploitation': review.cttp_nr==='5'}">{{ review.cttp_description }}</div>
                    <div style="grid-column: 1 / span 2; margin-top: 8px;">{{ review.huis_naam }}</div>
                    <div style="grid-column: 1 / span 2;" v-if="review.copy" class="copy">Internal copy</div>
                    <div style="grid-column: 1 / span 2;" v-if="review.copy" class="copy">Booking {{ review.huov_code }} (Org: {{ review.plan_code }})</div>
                </div>
            </div>
            <div>
                <div style="display: grid; grid-template-columns: repeat(3, 1fr)">                            
                    <div style="grid-column: 1 / span 2; font-weight: 700;" class="pt-1">Average score accommodation</div>
                    <v-avatar size="35" class="ml-3 logo_row_2" :class="`acco_score${review.avgReviewScoreRnd}`">{{review.avgReviewScore}}</v-avatar>
                    <div style="grid-column: 1 / span 3; font-weight: 400;" class="sub_script pb-2">
                        <div v-if="review.nrOfReviews===0">No published reviews yet</div>
                        <div v-else >Based on {{ review.nrOfReviews }} reviews</div>
                    </div>
                    <div class="sub_script">Key:</div>
                    <div class="sub_script" style="grid-column: 2 / span 2;">{{ review.key }}</div>
                    <div class="sub_script">Updated:</div>
                    <div class="sub_script" style="grid-column: 2 / span 2;">{{ review.updated_vfy }}</div>
                    <div class="sub_script">Uploaded:</div>
                    <div class="sub_script" style="grid-column: 2 / span 2;">{{ review.uploaded_vfy }}</div>
                </div>
            </div>
            <div>
                <div style="display: grid; grid-template-columns: repeat(4, 1fr)"> 
                        <!-- col 1-3  -->
                    <div style="grid-column: 1 / span 3; display: flex; flex-direction: row; margin-left: auto; margin-right:30px; align-items: center;">  
                        <!-- sent emails -->
                        <v-badge v-if="!!this.review.mail_aant" color="grey lighten-2" overlap bordered offset-y="35" offset-x="10" style="margin-top: 1px;">
                            <template v-slot:badge>
                                <span>{{review.mail_aant}}</span>
                            </template>                                                
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="pointer_hand" v-on:click="revwmails()">mdi-email-multiple-outline</v-icon>
                                </template>
                                <span>View sent e-mails</span>
                            </v-tooltip>    
                        </v-badge>
                        <!-- registered notes -->
                        <div>
                            <v-badge v-if="!!this.review.nott_aant" color="grey lighten-2" overlap bordered offset-y="35" offset-x="10">
                                <template v-slot:badge>
                                    <span>{{review.nott_aant}}</span>
                                </template>                                                
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" class="pointer_hand ml-6" v-on:click="nott(review.table, review.encrid)">mdi-note-multiple-outline</v-icon>
                                    </template>
                                    <span>View notes</span>
                                </v-tooltip>  
                            </v-badge>     
                            <v-tooltip v-else bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="pointer_hand ml-6" v-on:click="nott(review.table, review.encrid)">mdi-note-multiple-outline</v-icon>
                                </template>
                                <span>View notes</span>
                            </v-tooltip>                                                                                                       
                        </div>
                        <!-- send mail -->
                        <div>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="pointer_hand ml-6" v-on:click="send(review)">mdi-email-plus-outline</v-icon>
                                </template>
                                <span>Send e-mail to contact</span>
                            </v-tooltip>      
                        </div>
                    </div>
                    <!-- col 4 -->
                    <v-avatar size="60" :color="score_color"><h1>{{ review.score }}</h1></v-avatar>                                              
                </div>
            </div>
        </div>
        <!-- einde header section 1 -->

        <!-- header section 2 -->
        <div style="display: grid; grid-template-columns: repeat(2, 1fr);" class="px-8 mt-2">
            <div style="padding-top: 5px;">
                <div v-if="review.table === 'hogr'" @click="$router.open('/huov/onHuov/' + review.huov_encrid)">
                    <h4>Booking <a> {{ review.huov_code }} </a></h4>
                </div>
                <div v-else>
                    <div v-if="review.copy">
                        <h4 v-if="review.huov_code!==''">Booking<a> {{ review.huov_code }} </a></h4>
                        <h4 v-else>Booking</h4>
                    </div>
                    <div v-else>
                        <h4 v-if="review.huov_code!==''">Partner booking: {{ review.ota_huov_code }} (VfY: <a> {{ review.huov_code }} </a>)</h4>
                        <h4 v-else>Partner booking</h4>
                    </div>
                </div>       
            </div>
            <div style="border-top: 1px solid darkgray; padding-top: 5px;">
                <div v-if="review.url !== ''">
                    Visit accommodation {{ review.huis_code }} on <a :href=review.url target="_blank">{{ review.source }}</a>
                </div>
                <div v-else style="color: lightgrey;">No url available to visit this accommodation online</div>
            </div>                    
        </div>         
        <!-- einde header section 2 -->

        <!-- text-field and selection section -->
        <div style="display: grid; grid-template-columns: repeat(12, 1fr); gap: 15px; margin-top: 40px" class="px-8">
            <v-select v-if="review.table === 'hogr'" v-model="review.score" :items="review.scoreKeuzes" item-value="code" item-text="desc" label="Score" dense></v-select>
            <v-text-field v-else v-model="review.score" label="Score" dense readonly class="text-field-style"></v-text-field>
            <v-select style="grid-column: 2 / span 2;" v-model="review.status" :items="review.statusKeuzes" item-value="code" item-text="desc" label="Status" dense></v-select>
            <v-text-field style="grid-column: 4 / span 2;" v-model="review.created" label="Date / Time" dense readonly class="text-field-style text-grey"></v-text-field>
            <v-select style="grid-column: 6 / span 2;" v-model="review.gebr_code" v-bind:items="gebr" item-value="code" item-text="name" label="Assigned to" dense></v-select>
            <v-text-field style="grid-column: 8 / span 2;" v-model="review.huis_code" 
                @click="$router.open('/huis/onHuis/' + review.huis_encrid)" label="Accommodation" dense
                readonly class="text-field-style_a">
            </v-text-field>
            <v-text-field style="grid-column: 10 / span 3;" v-model="review.klnt_naam" label="Guest" dense readonly class="text-field-style"></v-text-field>
        </div>             
        <!-- einde text-field and selection section --> 

        <!-- links section -->
        <div class="px-8 mt-1 mb-1" style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 15px; align-items: center;"> 
            <div v-for="(link, idx) in review.links" :key="idx" style="display: flex; flex-direction: row; align-items: center; gap: 5px;">
                <div v-html="link.url"/>
                <v-icon small v-on:click="deleteLink(review.link.id)"> mdi-trash-can-outline</v-icon>
            </div>                              
            <div v-on:click="createlink()" style="font-variant: small-caps; font-size: 20px; margin-bottom: 5px;" class="createlink" :class="{'marginleft': review.links.length!==0}">create link</div>
        </div>         
        <!-- einde links section -->

        <!-- guestbook = review -->
        <div class="px-8">
            <div style="display: flex; flex-direction: row; align-items: end;">
                <v-tabs v-model="tab0">
                    <v-tab v-for="lng in review.details.guestbook" :key="lng.sort">
                        {{ lng.language}} <span v-if="lng.org"><v-icon color="error" size="20" class="ml-2">mdi-alpha-g-circle</v-icon></span><span v-if="lng.upd"><v-icon small color="warning" class="ml-2">mdi-alpha-t-circle</v-icon></span>
                    </v-tab>
                </v-tabs>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 15px; padding-left: 4px; padding-right: 4px; padding-bottom: 2px">
                    <v-btn small :disabled="isEmpty(review.details.guestbook[tab0])" @click="openTranslationDialog(review.details.guestbook[tab0])">translate</v-btn>
                </div>
            </div>      
            <v-tabs-items v-model="tab0">
                <v-tab-item v-for="lng in review.details.guestbook" :key="lng.sort">
                    <div class="mt-1" style="font-size: smaller;">Review text <span v-if="lng.text===''"> - empty</span></div>
                    <v-textarea v-model="lng.text" rows="8" :readonly="lng.org" counter no-resize />
                </v-tab-item>
            </v-tabs-items>
        </div>
        <!-- einde guestbook -->

        <!-- tips for host -->
        <div v-if="review.details.hasTipsforhost" class="px-8">
            <div style="display: flex; flex-direction: row; align-items: end;">
            <v-tabs v-model="tab1">
                <v-tab v-for="lng in review.details.tipsforhost" :key="lng.sort">
                    {{ lng.language}} <span v-if="lng.org"><v-icon color="error" size="20" class="ml-2">mdi-alpha-g-circle</v-icon></span><span v-if="lng.upd"><v-icon small color="warning" class="ml-2">mdi-alpha-t-circle</v-icon></span>
                </v-tab>
            </v-tabs>
            <div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 15px; padding-left: 4px; padding-right: 4px; padding-bottom: 2px">
                    <v-btn small :disabled="isEmpty(review.details.tipsforhost[tab1])" @click="openTranslationDialog(review.details.tipsforhost[tab1])">translate</v-btn>
                </div>
            </div>  
        </div>
            <v-tabs-items v-model="tab1">
                <v-tab-item v-for="lng in review.details.tipsforhost" :key="lng.sort">
                    <div class="mt-1" style="font-size: smaller">Tips for host <span v-if="lng.text===''"> - empty</span></div>
                    <v-textarea v-model="lng.text" rows="5" :readonly="lng.org" counter no-resize />
                </v-tab-item>
            </v-tabs-items>
        </div>    
        <!-- einde tips for host -->

        <!-- tips for vfy -->
        <div v-if="review.details.hasTipsforvfy" class="px-8">
            <div style="display: flex; flex-direction: row; align-items: end;">
                <v-tabs v-model="tab2">
                    <v-tab v-for="lng in  review.details.tipsforvfy" :key="lng.sort">
                        {{ lng.language}} <span v-if="lng.org"><v-icon color="error" size="20" class="ml-2">mdi-alpha-g-circle</v-icon></span><span v-if="lng.upd"><v-icon small color="warning" class="ml-2">mdi-alpha-t-circle</v-icon></span>
                    </v-tab>
                </v-tabs>
                <div>
                    <div style="display: flex; flex-direction: row; align-items: center; gap: 15px; padding-left: 4px; padding-right: 4px; padding-bottom: 2px">
                        <v-btn small :disabled="isEmpty(review.details.tipsforvfy[tab2])" @click="openTranslationDialog(review.details.tipsforvfy[tab2])">translate</v-btn>
                    </div>
                </div>  
            </div>
            <v-tabs-items v-model="tab2">
                <v-tab-item v-for="lng in review.details.tipsforvfy" :key="lng.sort">
                    <div class="mt-1" style="font-size: smaller">Tips for Villa for You <span v-if="lng.text===''"> - empty</span></div>
                    <v-textarea v-model="lng.text" rows="5" :readonly="lng.org" counter no-resize />
                </v-tab-item>
            </v-tabs-items>
        </div>    
        <!-- einde tips for vfy -->

        <!-- reaction VfY -->
        <div class="px-8" style="margin-bottom: 40px;">
            <div style="display: flex; flex-direction: row; align-items: end;">
                <v-tabs v-model="tab3">
                    <v-tab v-for="lng in  review.details.reactionvfy" :key="lng.sort">
                        {{ lng.language}} <span v-if="lng.org"><v-icon color="green" size="20" class="ml-2">mdi-alpha-o-circle</v-icon></span><span v-if="lng.upd"><v-icon small color="warning" class="ml-2">mdi-alpha-t-circle</v-icon></span>
                    </v-tab>
                </v-tabs>
                <div>
                    <div style="display: flex; flex-direction: row; align-items: center; gap: 15px; padding-left: 4px; padding-right: 4px; padding-bottom: 2px">
                        <v-btn small :disabled="isEmpty(review.details.reactionvfy[tab3])" @click="openAutoTranslationDialog(review.details.reactionvfy[tab3])">auto-translate</v-btn>
                        <v-btn small :disabled="isEmpty(review.details.reactionvfy[tab3])" @click="openTranslationDialog(review.details.reactionvfy[tab3])">translate</v-btn>
                    </div>
                </div>                  
            </div>
            <v-tabs-items v-model="tab3">
                <v-tab-item v-for="lng in review.details.reactionvfy" :key="lng.sort">
                    <div class="mt-1" style="font-size: smaller">Reaction Villa for You <span v-if="lng.text===''"> - empty</span></div>
                    <v-textarea v-model="lng.text" :readonly="review.table==='revw'" rows="5" counter no-resize />
                </v-tab-item>
            </v-tabs-items>
        </div>
        <!-- einde reaction VfY -->
        
        <!-- button bar -->
        <div class="px-8 my-2" style="display: flex; flex-direction: row; gap: 15px; align-items: center; padding-bottom: 40px;">                             
            <v-btn small class="primary ml-auto" @click="saveReview()">Save</v-btn>
            <v-btn small class="primary" @click="closeWindow()">Close</v-btn>
        </div>
        <!-- einde button bar -->

        <create_link ref="create_link" />
        <nott ref="nott" @addNote="setNoteNumber"/>
        <send_review ref="send_review"/>
        <revw_mails ref="revw_mails"/>
        <translateReviewText ref="translate_text" @updateData="useTranslation" />
        <autoTranslateReaction ref="auto_translate_reaction" @updateData="createAutoTranslationInstruction" />
    </div>
</template>
<script>
import mxgetuser from '@/mixins/getuser'
import mximage from '@/mixins/responsive_image'
import mxfindwithattribute from '@/mixins/findwithattribute'
import create_link from '@/components/create_link.vue'
import nott from '@/components/nott.vue'
import send_review from '@/views/task/customer_success/revw/sendReview.vue'
import revw_mails from '@/views/task/customer_success/revw/showRevwMail.vue'
import translateReviewText from "@/views/task/customer_success/revw/translateRevwText";
import autoTranslateReaction from "@/views/task/customer_success/revw/autoTranslateReaction";
export default {    
    components: {        
        create_link, nott, send_review, revw_mails, translateReviewText, autoTranslateReaction
    },
    props: ['param'],
    mixins: [mxgetuser, mxfindwithattribute, mximage],
    data() {
        return {
            table: '',
            encrid: '',
            review: {},
            tab0: null,
            tab1: null,
            tab2: null,
            tab3: null,
            loading: true,
        }
    },
    created() {        
        this.aquireImages();           
    },
    mounted() {
        if (this.param) {
            this.table = this.param.split(':')[0] 
            this.encrid = this.param.split(':')[1] 
        }
        this.getGebr();
        this.getReview('x')
    },
    computed: {
        score_color: function () {
            var idx = this.findWithAttr(this.review.colors, "code", this.review.score); // code, name zoeken in, naar, met waarde
            if (idx !== -1) {
                return this.review.colors[idx].color;
            }
            return this.review.color_code;
        },        
    },
    methods: {
        getReview(param) {
            this.loading = true
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/getReview.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getReview"
                    },
                    getReview: {
                        table: this.table,
                        encrid: this.encrid
                    }
                })
                .then(async res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.review = res.data.getReview;
                        console.log('start', res.data.getReview)
                        document.title = `Rev. ${this.review.key}`
                        if(param==='x'){
                            this.tab0 = this.review.tab0
                            this.tab1 = this.review.tab1
                            this.tab2 = this.review.tab2
                            this.tab3 = this.review.tab3
                        }
                        this.loading = false
                    }
                });
        },
        openTranslationDialog(textObject){
            this.$refs.translate_text.open(textObject);  
        },
        openAutoTranslationDialog(textObject){
            this.$refs.auto_translate_reaction.open(textObject, this.review.table, this.encrid);  
        },     
        setNoteNumber(data){
            this.review.nott_aant+=data
        },   
        useTranslation(data){
            this.review.details[(data.type).toLowerCase()].forEach(x => {
                if(x.language === data.target){
                    x.text = data.resultText
                    x.upd = true
                }
            })
            this.review.details[(data.type).toLowerCase()].text=data.resultText
            this.review.details[(data.type).toLowerCase()]
            this.saveReview()
        },
        closeWindow(){
            window.open('', '_self', ''); window.close();
        },
        getUUID(){
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
        },          
        async createAutoTranslationInstruction(){
            await this.getReview()
        },
        async saveReview() {
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/saveReview2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "saveReview"
                    },
                    saveReview: this.review,
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        var idx = this.findWithAttr(this.gebr, "code", this.review.gebr_code); // code, name zoeken in, naar, met waarde
                        if (idx !== -1) {
                            this.review.display_name = this.gebr[idx].name;
                        }
                        this.review.color_code = this.score_color;
                        localStorage.setItem('reload_reviews', this.getUUID());
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: "Changes saved",
                            color: "success"
                        });                        
                    }
                })
        },        
        getReviewSource(v){
            return v==='VillaForYou'?'vfy':typeof v!=='undefined'?v.toLowerCase():''
        },        
        aquireImages(){
            this.loadImage(require('@/assets/_airbnb.svg'), 'airbnb', 80);
            this.loadImage(require('@/assets/_bookingcom.svg'), 'booking', 60);
            this.loadImage(require('@/assets/_vrbo_logo.svg'), 'vrbo', 80);
            this.loadImage(require('@/assets/_vfy_logo.svg'), 'vfy', 80);
            this.loadImage(require('@/assets/_holidu_logo.svg'), 'holidu', 80);            
        },        
        revwmails(){
            this.$refs.revw_mails.open(this.review);
        },              
        nott(table, encrid) {
            this.$refs.nott.open(table, encrid, "all");
        },
        createlink() {
            this.$refs.create_link.open(this.review.links);
        },
        send(review) {
            this.$refs.send_review.open(review);
        },        
        deleteLink(param) {
            let idx = this.findWithAttr(this.review.links, "id", param);
            this.review.links.splice(idx, 1);
        },     
        isEmpty(txt){
            return typeof txt!=='undefined'?txt.text==='':true
        } 
    }
}

</script> 
  
<style scoped>
    .sub_script {
        font-size: 13px !important;
    }
    .acco_score0 {
        background: transparent !important;
        border: 2px solid lightgrey;
    }
    .acco_score1 {
        background: transparent !important;
        border: 2px solid #FD535E;
    }
    .acco_score2 {
        background: transparent !important;
        border: 2px solid #FD7B3F;
    }
    .acco_score3 {
        background: transparent !important;
        border: 2px solid #FCC700;
    }
    .acco_score4 {
        background: transparent !important;
        border: 2px solid #65D557;
    }
    .acco_score5 {
        background: transparent !important;
        border: 2px solid #0FC771;
    }
    .pointer_hand{
        cursor: pointer;
    }
    .copy {
        font-weight: 500; font-size: 10pt; color: orange;
    }
    .createlink:hover {
        cursor: pointer;
        color: blue;
        font-weight: 500;
    }
    .marginleft{
        margin-left: 15px;
    }  
    .exploitation{
        color: red;
    }  
</style>